import client from "./ApiService";

class RoyaltiesPhotographerService {
  constructor(params) {
    this.url = "/royalties-photographers";
  }

  get() {
    return client.get(this.url);
  }

  filter(filter) {
    return client.get(`${this.url}${filter ? '?name_contains='+filter : ''}`);
  }

  slugfilter(filter) {
    return client.get(`${this.url}${filter ? '?_q='+filter : ''}`);
  }
}

export default new RoyaltiesPhotographerService();
